export default "__VITE_ASSET__iXDdCvrE__"